<app-header></app-header>

<div class="cardOpcion-multicolor div-encuesta" cdkDrag [cdkDragFreeDragPosition]="dragPosition">
    <div class="menu_boton div-boton-encuesta" (click)="openDialogOpinion()">
        <a class="a-link-boton-encuesta">
            <p class="p-texto-menu-app">Conozca la nueva sección de estadísticas económicas</p>
        </a>
    </div>
</div>
<div class="contenedor_principal">
    <div class="contenidoDivTitulo div-titulo-video">
        <h1 class="h1-titulo-app">{{constante.ETIQUETA_TITULO_APLICACION}}</h1>
    </div>
    <div class="div-linea-titulo"></div>
    <app-menu-mas-consultados></app-menu-mas-consultados>
    <div class="div-linea-titulo"></div>
    <div class="div-catalogo-inicial">
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">
                <div class="div-imagen-opcion">
                    <div class="div-rompecabeza-container">
                        <div class="div-parte-rompecabeza" (click)="abrirPagina('catalogo')" title="Consulta lista de datos disponibles y algunos de nuestros datos más populares">                               
                            <div class="div-inferior" style="background: url(/estadisticas-economicas/assets/img/menu-inicial/catalogo_1.png) no-repeat; background-size: 160px 72px; background-position: bottom;">
                                <p class="div-texto-catalogo-up">{{ constante.ETIQUETA_BOTON_CATALOGO }}</p>
                            </div>
                        </div>
                        <div class="div-parte-rompecabeza" (click)="abrirPagina('graficador')" title="Grafique y consulte los datos de su interés">
                            <div class="div-superior" style="background: url(/estadisticas-economicas/assets/img/menu-inicial/catalogo_4.png) no-repeat; background-size: 160px 72px; background-position: bottom;">
                                <p class="div-texto-catalogo-up">{{ constante.ETIQUETA_BOTON_GRAFICADOR_H }}</p>
                            </div>
                        </div>
                        <div class="div-parte-rompecabeza" (click)="abrirPagina('dashboard')" title="Consulte reportes prediseñados por los técnicos del banco">
                            <div class="div-superior" style="background: url(/estadisticas-economicas/assets/img/menu-inicial/catalogo_3.png) no-repeat; background-size: 160px 72px; background-position: top; position: relative;">
                                <p class="div-texto-catalogo">{{ constante.ETIQUETA_BOTON_TABLA_GRAFICO_PRECONSTRUIDO }}</p>
                            </div>
                        </div>
                        <div class="div-parte-rompecabeza" (click)="abrirPagina('shopping')" title="Consulte de forma granular los datos">
                            <div class="div-inferior" style="background: url(/estadisticas-economicas/assets/img/menu-inicial/catalogo_2.png) no-repeat; background-size: 160px 72px; background-position: top; position: relative;">
                                <p class="div-texto-catalogo">{{ constante.ETIQUETA_BOTON_BUSCADOR_CORTO }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="div-nombre-opcion-catalogo"
                id="titulo_catalogo">
                {{constante.ETIQUETA_BOTON_NUESTROS_DATOS}}
            </div>
        </div>
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">
                <div class="div-imagen-opcion">
                    <img tabindex="0" src="{{imgCalendario}}" class="imagen-opcion" (click)="abrirPagina('calendario')">
                </div>
            </div>
            <div class="div-nombre-opcion-catalogo" id="series_web">
                {{constante.ETIQUETA_BOTON_CALENDARIO}}
            </div>
        </div>
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">  
                <div class="div-imagen-opcion">
                    <div class="grid-container">
                        <div class="grid-celda grid-celda-1" (click)="abrirPagina('estadisticaEncuesta')">
                            <img class="img-rompecabeza-encuesta" src="/estadisticas-economicas/assets/img/menu-inicial/boletin-col-1.jpg" alt="">
                            <div class="div-texto-rompecabeza" [innerHTML]="">{{constante.ETIQUETA_BOTON_ENCUESTAS}}</div>                            
                        </div>
                        <div class="grid-celda grid-celda-2" (click)="abrirPagina('boletines')">
                            <img class="img-rompecabeza-encuesta" src="/estadisticas-economicas/assets/img/menu-inicial/boletin-col-2.jpg" alt="">
                            <div class="div-texto-rompecabeza" [innerHTML]="constante.ETIQUETA_BOTON_BOLETINES"></div>                            
                        </div>
                      </div>
                </div>
            </div>
            <div class="div-nombre-opcion-catalogo" id="audiorespuesta_aud">
                {{constante.ETIQUETA_BOTON_ENCUESTA_EXPECTATIVA_BOLETIN}}
            </div>
        </div>
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">
                <div class="div-imagen-opcion">
                    <img tabindex="0" src="{{imgAudiorespuesta}}" class="imagen-opcion" (click)="abrirPagina('audiorespuesta')">
                </div>
            </div>
            <div class="div-nombre-opcion-catalogo" id="audiorespuesta_aud">
                {{constante.ETIQUETA_BOTON_INDICADORES}}
            </div>
        </div>
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">
                <div class="div-imagen-opcion">
                    <img tabindex="0" src="{{imgWebserice}}" class="imagen-opcion" (click)="abrirPagina('webService')">
                </div>
            </div>
            <div class="div-nombre-opcion-catalogo" id="webservice_web">
                {{constante.ETIQUETA_BOTON_WEB_SERVICE}}
            </div>
        </div>
        <div class="menu_central_slider">
            <div class="div-caja-catalogo">
                <div class="div-imagen-opcion">
                    <img tabindex="0" src="{{imgHistorico}}" class="imagen-opcion" (click)="abrirPagina('historico')">
                </div>                
            </div>
            <div class="div-nombre-opcion-catalogo" id="series_web">
                {{constante.ETIQUETA_BOTON_HISTORICO}}
            </div>
        </div>
    </div>
</div>